import * as React from 'react'
import { useEventListener } from 'usehooks-ts'

const MOBILE_BREAKPOINT = 1024

// 🌏 This compoent is originally generated by
// 🌏 https://ui.shadcn.com/docs/components/sidebar
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    mql.addEventListener('change', onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)

    return () => mql.removeEventListener('change', onChange)
  }, [])

  useEventListener('resize', () => {
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
  })

  return !!isMobile
}
